import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class StackBaseValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        if (!stacking.exposure) {
            this.addError('You should set exposure.');
        }
        Object.keys(stacking.groups).map((groupNumber) => {
            let group = stacking.groups[groupNumber];
            if (!group.team) {
                this.addError('You should set team.');
            }
            if (isEmpty(group.lineGroups)) {
                this.addError('You should set line group.');
            }
        });
    }
}

export default StackBaseValidator;
